import { Reveal } from "./Reveal";

export function Eyebrow({ children, dark = false }) {
  return (
    <p className={`font-display text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-navy/50" : "text-revo-green"}`}>
      {children}
    </p>
  );
}

export function Chapter({ num, children, dark = false }) {
  return (
    <span className={`font-display text-sm font-medium tabular-nums ${dark ? "text-navy/40" : "text-revo-ice/50"}`}>
      {num}
    </span>
  );
}

export function SpecStrip({ specs, dark = false }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="spec-strip">
      {specs.map((s) => (
        <span
          key={s}
          className={`rounded-full border px-3 py-1.5 text-xs font-medium ${
            dark ? "border-navy/15 bg-navy/5 text-navy/80" : "border-white/15 bg-white/5 text-revo-ice"
          }`}
        >
          {s}
        </span>
      ))}
    </div>
  );
}

export function PageHeader({ eyebrow, title, subtitle, dark = true }) {
  return (
    <section className={`relative overflow-hidden px-5 pb-16 pt-36 md:px-8 md:pb-24 md:pt-44 ${dark ? "bg-navy text-white" : "bg-white text-navy"}`}>
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow dark={!dark}>{eyebrow}</Eyebrow>
          <h1 className={`mt-4 max-w-4xl font-display text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-navy"}`}>
            {title}
          </h1>
          {subtitle && (
            <p className={`mt-6 max-w-2xl text-lg leading-relaxed ${dark ? "text-revo-ice" : "text-navy/70"}`}>{subtitle}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}

export function StraightTalk({ title, children }) {
  return (
    <section className="relative overflow-hidden bg-navy px-5 py-24 md:px-8 grain">
      <div className="mx-auto max-w-4xl">
        <Reveal>
          <Eyebrow>Straight talk</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-black leading-tight text-white sm:text-4xl lg:text-5xl">{title}</h2>
          <div className="mt-6 space-y-5 text-lg leading-relaxed text-revo-ice">{children}</div>
        </Reveal>
      </div>
    </section>
  );
}
